<ng-container *ngIf="isLoading">
    <div class="u2b-loading-shade">
        <mat-spinner></mat-spinner>
    </div>
</ng-container>
<div [class.disabled]="isLoading" class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane"
     cdkDragBoundary="body">
    <form [formGroup]="formGroup" appInvalidControlScroll
          [scrollContainer]="scrollContainer">

        <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">
                    {{ assignmentTitleTranslated }}
                    <ng-container *ngIf="givenBerth as b">
                        {{ 'workflows.screens.berthReservation.toolbarBerthSuffix' | translate: { handle: b.handle } }}
                    </ng-container>
                </h2>
                <button data-test="B-Close-dialog" mat-icon-button (click)="onClickClose()"
                        [attr.aria-label]="'common.closeDialogAria' | translate" type="button">
                    <mat-icon>close</mat-icon>
                </button>
    </mat-toolbar>

        <div mat-dialog-content #scrollContainer>

            <ng-container *ngIf="showAssignmentTypeSelect">
                <div>
                    <mat-form-field fxFlex="100" appearance="outline" floatLabel="always">
                        <mat-label>Reservierung / Buchung</mat-label>
                        <mat-select data-test="FS-Typ"
                                    formControlName="assignmentType">
                            <mat-option [value]="BerthAssignmentType.Reservation">
                                Reservierung
                            </mat-option>
                            <mat-option [value]="BerthAssignmentType.Booking">
                                Buchung
                            </mat-option>
                        </mat-select>
                        <mat-error>{{ formGroup.get('assignmentType').errors | firstErrorMessage }}</mat-error>
                    </mat-form-field>
                </div>
            </ng-container>

            <form-widget-date-range [parentFormGroup]="formGroup"
                                    [headline]="'workflows.screens.berthReservation.dateRangeHeadline' | translate"
                                    [from]="givenFromDate"
                                    [fromLabel]="'workflows.screens.berthReservation.dateFromLabel' | translate"
                                    [to]="givenToDate"
                                    [toLabel]="'workflows.screens.berthReservation.dateToLabel' | translate"></form-widget-date-range>

            <ng-container *ngIf="defaultBerthReservationTimeUnit?.type && durationOfStay > 0">
                <u2b-message type="info" class="mt-16" [collapsable]="true"
                             [header]="'workflows.screens.berthReservation.durationInfoHeader' | translate: { title: assignmentTitleTranslated, duration: durationOfStay, unitShort: durationUnitShortTranslated }">
                    <p [innerHTML]="'workflows.screens.berthReservation.settingsBillingIntroHtml' | translate: { title: assignmentTitleTranslated, unitWord: billingUnitWordTranslated }"></p>
                    <p>&nbsp;</p>
                    <ng-container
                            *ngIf="defaultBerthReservationTimeUnit.type === DEFAULT_BERTH_RESERVATION_UNIT.OVERNIGHT_STAY">
                        <p [innerHTML]="'workflows.screens.berthReservation.overnightWindowHtml' | translate: {
                            fromTime: defaultBerthReservationTimeUnit.fromHours + ':' + defaultBerthReservationTimeUnit.fromMinutes,
                            toTime: defaultBerthReservationTimeUnit.toHours + ':' + defaultBerthReservationTimeUnit.toMinutes
                        }"></p>
                        <p>&nbsp;</p>
                    </ng-container>
                    <p [innerHTML]="'workflows.screens.berthReservation.durationThisHtml' | translate: { title: assignmentTitleTranslated, duration: durationOfStay, unitShort: durationUnitShortTranslated }"></p>
                    <p>&nbsp;</p>
                    <p>{{ 'workflows.screens.berthReservation.arrivalLabel' | translate }} {{ formGroup.get('dateRangeForm')?.get('from')?.value | dateTimeFormat: 'dd.MM. hh:mm' }}</p>
                    <p>{{ 'workflows.screens.berthReservation.departureLabel' | translate }} {{ formGroup.get('dateRangeForm')?.get('to')?.value | dateTimeFormat: 'dd.MM. hh:mm' }}</p>
                    <ng-container
                            *ngIf="defaultBerthReservationTimeUnit.type === DEFAULT_BERTH_RESERVATION_UNIT.OVERNIGHT_STAY && (!isAfterPeriodStarts || isAfterPeriodEnds)">
                        <p>&nbsp;</p>
                        <p>– {{ 'workflows.screens.berthReservation.equalsOvernights' | translate: { count: totalDays } }}</p>
                        <ng-container *ngIf="!isAfterPeriodStarts">
                            <p>– {{ 'workflows.screens.berthReservation.extraOvernightBefore' | translate: {
                                time: defaultBerthReservationTimeUnit.fromHours + ':' + defaultBerthReservationTimeUnit.fromMinutes
                            } }}</p>
                        </ng-container>
                        <ng-container *ngIf="!sameDay && isAfterPeriodEnds">
                            <p>– {{ 'workflows.screens.berthReservation.extraOvernightAfter' | translate: {
                                time: defaultBerthReservationTimeUnit.toHours + ':' + defaultBerthReservationTimeUnit.toMinutes
                            } }}</p>
                        </ng-container>
                    </ng-container>
                </u2b-message>
            </ng-container>

            <mat-divider class="special-divider"></mat-divider>

            <ng-container *ngIf="!givenBerth">
                <form-widget-berth-only [parentFormGroup]="formGroup"></form-widget-berth-only>
                <mat-divider class="special-divider"></mat-divider>
            </ng-container>

            <section>
                <mat-checkbox (change)="captureBoatChange($event)"
                              [checked]="captureBoat">
                    {{ 'workflows.berthReservation.captureBoat' | translate }}
                </mat-checkbox>

                <ng-container *ngIf="captureBoat">
                    <form-widget-boat [givenBerth]="givenBerth"
                                      [canSave]="true"
                                      [showMetaData]="true"></form-widget-boat>

                    <ng-container *ngIf="boatToHeavy">
                        <u2b-message type="warning" [customClass]="'mt-16'">
                            <header>{{ 'boats.berthAssignmentWarnings.tooHeavyForBuoyTitle' | translate }}</header>
                            <p [innerHtml]="'boats.berthAssignmentWarnings.tooHeavyForBuoyText' | translate : {
                                    'berthMaxWeight': (berthMaxWeight | number: '1.0-2'),
                                    'boatWeight': (boatWeight | number: '1.0-2'),
                                    'boatToHeavy': (boatToHeavy | number: '1.0-2')
                                }">
                            </p>
                        </u2b-message>
                    </ng-container>

                    <ng-container *ngIf="boatToLong || boatToWide">
                        <u2b-message type="warning" [customClass]="'mt-16'">
                            <header>{{ 'boats.berthAssignmentWarnings.doesNotFitBerthTitle' | translate }}</header>
                            <ng-container *ngIf="boatToLong">
                                <p [innerHtml]="'boats.berthAssignmentWarnings.lengthDoesNotFitBerth' | translate : {
                                        'boatToLong': (boatToLong | number: '1.0-2'),
                                        'berthLength': (givenBerth.length | number: '1.0-2')
                                    }">
                                </p>
                            </ng-container>
                            <ng-container *ngIf="boatToWide">
                                <p [innerHtml]="'boats.berthAssignmentWarnings.widthDoesNotFitBerth' | translate : {
                                        'boatToWide': (boatToWide | number: '1.0-2'),
                                        'berthLength': (givenBerth.width | number: '1.0-2')
                                    }">
                                </p>
                            </ng-container>
                        </u2b-message>
                    </ng-container>

                    <mat-divider class="special-divider"></mat-divider>
                </ng-container>
            </section>

            <h2>
                {{ givenBerthAssignmentType === BerthAssignmentType.Reservation
                    ? ('workflows.screens.berthReservation.whoReserves' | translate)
                    : ('workflows.screens.berthReservation.whoBooks' | translate) }}
            </h2>

            <ng-container *ngIf="formGroupPrepare.get('type').touched && formGroupPrepare.get('type').errors">
                <u2b-message type="warning">
                    {{ formGroupPrepare.get('type').errors | firstErrorMessage }}
                </u2b-message>
            </ng-container>

            <div [formGroup]="formGroupPrepare">
                <mat-radio-group class="radio-group-inline" formControlName="type">
                    <mat-radio-button [value]="'person'">{{ 'person.singular' | translate }}</mat-radio-button>
                    <mat-radio-button [value]="'organisation'">{{ 'company.singular' | translate }}</mat-radio-button>
                </mat-radio-group>
            </div>

            <ng-container *ngIf="formGroupPrepare.get('type').value === 'person'">
                <form-widget-person [optionalFields]="true"></form-widget-person>
            </ng-container>

            <ng-container *ngIf="formGroupPrepare.get('type').value === 'organisation'">
                <form-widget-company [optionalFields]="true"></form-widget-company>
            </ng-container>

            <ng-container *ngIf="showIsOwnerCheckBox && boatName && boatOwnerName">
                <div class="mt-24">
                    <mat-checkbox formControlName="isOwner">
                        {{ 'boats.bookingDialog.nameIsOwner' | translate : { boatOwnerName: boatOwnerName, boatName: boatName } }}
                    </mat-checkbox>
                </div>
            </ng-container>

            <mat-divider class="special-divider"></mat-divider>

            <section>
                <mat-checkbox (change)="captureTenantRelationChange($event)"
                              [checked]="captureTenantRelation">
                    {{ 'workflows.screens.berthReservation.captureTenantRelation' | translate }}
                </mat-checkbox>

                <ng-container *ngIf="captureTenantRelation">
                    <form-widget-tenant-relation [parentFormGroup]="formGroup"
                                                 [headline]="null"
                                                 [givenBerth]="givenBerth"
                                                 [prefilledTenantRelationId]="prefilledTenantRelationId"></form-widget-tenant-relation>
                    <mat-divider class="special-divider"></mat-divider>
                </ng-container>
            </section>

            <section>
                <mat-checkbox (change)="captureContract = $event.checked"
                              [checked]="captureContract">
                    {{ 'workflows.screens.berthReservation.captureContract' | translate }}
                </mat-checkbox>

                <ng-container *ngIf="captureContract">
                    <form-widget-contract [parentFormGroup]="formGroup"></form-widget-contract>
                </ng-container>

                <mat-divider class="special-divider"></mat-divider>
            </section>

            <section>
                <form-widget-invoice [parentFormGroup]="formGroup"
                                     [givenStartDate]="givenFromDate"
                                     [givenEndDate]="givenToDate"
                                     [givenInvoicePositions]="givenInvoicePositions"
                                     [showAddBerthPositionButton]="true"
                                     [showInvoiceCreationCheckBox]="true"
                                     [givenTenantRelation]="formGroup.get('tenantRelationForm')?.value?.tenantRelation"
                                     [givenBerth]="givenBerth"></form-widget-invoice>
                <mat-divider class="special-divider"></mat-divider>
            </section>

            <ng-container *ngIf="givenBerthAssignmentType === BerthAssignmentType.Reservation">
                <section>
                    <mat-checkbox (change)="captureReservedUntil = $event.checked"
                                  [checked]="captureReservedUntil">
                        {{ 'workflows.screens.berthReservation.reservedUntilCheckbox' | translate }}
                    </mat-checkbox>

                    <ng-container *ngIf="captureReservedUntil">
                        <div class="mt-24">
                            <app-input-date-time formControlName="reservedUntil" appearance="fill"
                                                 [defaultTime]="reservedUntilDefaultTime">
                                <label>{{ 'workflows.screens.berthReservation.reservedUntilLabel' | translate }}</label>
                            </app-input-date-time>
                        </div>
                    </ng-container>
                </section>
            </ng-container>

            <!-- todo: need to add mail templates first.. -->
            <!--            <section>-->
            <!--                <mat-checkbox (change)="sendMail = $event.checked"-->
            <!--                              [checked]="sendMail">-->
            <!--                    Reservierung per E-Mail senden-->
            <!--                </mat-checkbox>-->

            <!--                <ng-container *ngIf="sendMail">-->
            <!--                    <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">-->
            <!--                        <mat-label>E-Mail</mat-label>-->
            <!--                        <input matInput data-test="FI-E-Mail" type="text" formControlName="mail"-->
            <!--                               autocomplete="new-password">-->
            <!--                    </mat-form-field>-->
            <!--                </ng-container>-->
            <!--            </section>-->

            <div class="mt-24">
                <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
                    <mat-label>{{ 'workflows.screens.berthReservation.noteLabel' | translate: { title: assignmentTitleTranslated } }}</mat-label>
                    <textarea #noteText
                              matInput
                              [attr.data-test]="'FT-Bemerkungen zur Liegeplatznutzung'"
                              formControlName="note"
                              autocomplete="new-password"
                              [cdkTextareaAutosize]="true"
                              [cdkAutosizeMinRows]="3"
                              [cdkAutosizeMaxRows]="5"
                              [maxLength]="1024"></textarea>
                    <mat-error>{{ formGroup.get('note').errors | firstErrorMessage }}</mat-error>
                    <mat-hint align="end">
                        {{ 'accounting.invoiceSettings.charsUsed' | translate: { used: noteText.value?.length || 0, max: 1024 } }}
                    </mat-hint>
                </mat-form-field>
            </div>

            <mat-divider class="special-divider"></mat-divider>

            <ng-container
                    *ngIf="(formGroup.dirty && formGroup.invalid) || (formGroupPrepare.dirty && formGroupPrepare.invalid) || !canSave">
                <u2b-message type="warning" customClass="mt-24">
                    {{ 'workflows.shared.formInvalidHint' | translate }}
                </u2b-message>

                <ng-container *ngIf="!canSave">
                    <u2b-message type="error" customClass="mt-24">
                        <div [innerHTML]="'workflows.screens.berthReservation.boatMissingHintHtml' | translate: { boat: ('boats.singular' | translate) }"></div>
                    </u2b-message>
                </ng-container>
            </ng-container>

            <ng-container
                    *ngIf="(formGroup.dirty && formGroup.valid) && (formGroupPrepare.dirty && formGroupPrepare.valid) && canSave">
                <u2b-message type="success" customClass="mt-24">
                    <header>{{ 'workflows.shared.formCompleteTitle' | translate }}</header>
                    {{ 'workflows.shared.formCompleteSaveHint' | translate }}
                </u2b-message>
            </ng-container>
        </div>

        <div mat-dialog-actions class="m-0 p-8 p-sm-16" fxLayout="row" fxLayoutAlign="space-between center">

            <button data-test="B-Abbrechen" mat-flat-button (click)="onClickClose()" type="button">
                {{ 'common.cancel' | translate }}
            </button>

            <div>
                <ng-template #saving>
                    <mat-icon>save</mat-icon>
                    <span>{{ 'common.saving' | translate }}</span>
                    <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
                </ng-template>

                <ng-template #notSaving>
                    <mat-icon>save</mat-icon>
                    <span>{{ 'workflows.screens.berthReservation.saveAction' | translate: { title: assignmentTitleTranslated } }}</span>
                </ng-template>

                <button (click)="onClickSaveAndClose()" data-test="B-Speichern" mat-flat-button color="accent"
                        [disabled]="isSaving || !canSave">
                    <ng-container *ngIf="isSaving; then saving else notSaving"></ng-container>
                </button>
            </div>

        </div>
    </form>
</div>
